import Container from "../../styles/container";
import { LoginStyled, IconButton, RegisterSection } from "./styles";
import { FormButton, LinkButton } from "../../components/Button";
import StyledLogo from "../../components/Logo/styles";
import { UserContext } from "../../contexts/UserContext";
import { StyledForm, StyledAlert } from "../../components/Form/styles";
import { MdVisibility, MdVisibilityOff, MdErrorOutline } from "react-icons/md";

import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { motion } from "framer-motion";

import { useState, useContext } from "react";

interface ILogin {
  email: string;
  password: string;
}

const Login = () => {
  const { handleLogin } = useContext(UserContext);
  const [showPassword, setShowPassword] = useState(false);

  const schema = yup.object({
    email: yup.string().email("Email inválido").required("Email obrigatório"),
    password: yup.string().required("Senha obrigatória"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ILogin>({
    resolver: yupResolver(schema),
  });

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <motion.div
      initial={{ opacity: 0, originY: 0.5 }}
      animate={{ opacity: 1, originY: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Container>
        <LoginStyled>
          <StyledLogo>Kenzie Hub</StyledLogo>
          <section>
            <StyledForm onSubmit={handleSubmit(handleLogin)}>
              <h4>Login</h4>
              <label htmlFor="email">Email</label>
              <div className="inputContent">
                <input type="text" id="email" {...register("email")} />
                {errors.email && (
                  <StyledAlert>
                    <MdErrorOutline />
                    <p> {errors.email.message} </p>
                  </StyledAlert>
                )}
              </div>
              <label htmlFor="password">Senha</label>
              <div className="inputContent">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  {...register("password")}
                />
                <IconButton onClick={handleShowPassword} type={"button"}>
                  {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                </IconButton>
                {errors.password && (
                  <StyledAlert>
                    <MdErrorOutline />
                    <p> {errors.password.message} </p>
                  </StyledAlert>
                )}
              </div>
              <FormButton
                link=""
                buttonSize="default"
                buttonStyle={"default"}
                type="submit"
              >
                Entrar
              </FormButton>
            </StyledForm>
            <RegisterSection>
              <span>Ainda não possui uma conta?</span>
              <LinkButton
                link={"register"}
                buttonStyle={"disable"}
                buttonSize="default"
              >
                Cadastre-se
              </LinkButton>
            </RegisterSection>
          </section>
        </LoginStyled>
      </Container>
    </motion.div>
  );
};

export default Login;
